import RetoolComp from "./retool_components/retool";

export const Demand = () => {
  const deal_uuid = "8fc0ec3e-7376-11ee-96c4-9be96be2126e";
  return <RetoolComp component_uuid={deal_uuid} />;
};
